import { ref, computed, watch, readonly } from 'vue';

const STORAGE_KEY = 'nido.theme';

function readInitial() {
    if (typeof window === 'undefined') return 'light';
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (stored === 'light' || stored === 'dark') return stored;
    } catch (e) {
        // almacenamiento deshabilitado (modo privado, política IT, etc.)
    }
    if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
        return 'dark';
    }
    return 'light';
}

function applyTheme(value) {
    if (typeof document === 'undefined') return;
    if (value === 'dark') {
        document.documentElement.setAttribute('data-theme', 'dark');
    } else {
        document.documentElement.removeAttribute('data-theme');
    }
}

const current = ref(readInitial());
let initialized = false;

export function useTheme() {
    if (!initialized && typeof window !== 'undefined') {
        initialized = true;
        applyTheme(current.value);
    }

    const isDark = computed(() => current.value === 'dark');

    function set(value) {
        if (value !== 'light' && value !== 'dark') return;
        current.value = value;
    }

    function toggle() {
        set(current.value === 'dark' ? 'light' : 'dark');
    }

    watch(current, (value) => {
        if (typeof window === 'undefined') return;
        applyTheme(value);
        try {
            window.localStorage.setItem(STORAGE_KEY, value);
        } catch (e) {
            // sin storage: la preferencia se mantiene sólo en memoria
        }
    });

    return {
        theme: readonly(current),
        isDark,
        setTheme: set,
        toggle,
    };
}

export const NIDO_THEME_STORAGE_KEY = STORAGE_KEY;
